module.exports = __webpack_public_path__ + "media/img/android-icon-192x192-1fdf071a910a297bd794afb41c2b5c66.png";